// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2gRec","col":"styles_col__qTSLS"};